var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.5 38.5",
    id: "x",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.59,
    x2: 35.91,
    y1: 9.63,
    y2: 28.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M38.5,19.25c0,.52-.02,1.03-.07,1.54-.37,4.68-2.44,8.91-5.58,12.06-3.49,3.49-8.3,5.65-13.6,5.65-1.43,0-2.82-.16-4.15-.46-.94-.2-1.84-.47-2.72-.81C5.16,34.45,0,27.42,0,19.25c0-5.29,2.17-10.11,5.65-13.6C9.14,2.16,13.95,0,19.25,0s10.11,2.16,13.6,5.65c2.18,2.19,3.85,4.9,4.79,7.92.41,1.33.68,2.71.79,4.14.01.1.02.21.02.31.04.41.05.81.05,1.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M38.5,19.25c0,.52-.02,1.03-.07,1.54-.37,4.68-2.44,8.91-5.58,12.06-3.49,3.49-8.3,5.65-13.6,5.65-1.43,0-2.82-.16-4.15-.46l-6.99-7.32,8.59-9.97-8.46-12.31h7.33l6.28,6.32,5.43-6.32h3.04l7.81,8.36c.12.4.23.81.32,1.22.04.41.05.81.05,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.88,30.72h-7.33l-5.5-8.01-6.89,8.01h-3.04l8.58-9.97-8.45-12.3h7.33l5.2,7.57,6.51-7.57h3.04l-8.2,9.53,8.76,12.74ZM24.03,29.81h5.13l-8.18-11.9,7.37-8.57h-.65l-7.01,8.15-5.6-8.15h-5.13l7.88,11.46-7.75,9.01h.65l7.39-8.59,5.9,8.59ZM28.36,29.39h-3.94L10.74,9.83h3.94l13.68,19.56ZM24.89,28.49h1.73L14.21,10.74h-1.73l12.41,17.75Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.963712235cda9b2f25495cc686f3bdca.svg";
export { ForwardRef as ReactComponent };